module.exports = __webpack_public_path__ + "static/media/hero_video.068b9a74.mp4";